/**
 * @generated SignedSource<<ff430cc8c7c047af4088716110241975>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IdentityAccountTypes = "CANDIDATE" | "EMPLOYER" | "INTERNAL" | "%future added value";
export type IdentityUserDetailsRouteQuery$variables = {
  identityUserCode: number;
};
export type IdentityUserDetailsRouteQuery$data = {
  readonly identityUser: {
    readonly __id: string;
    readonly accountTypes: ReadonlyArray<IdentityAccountTypes>;
    readonly adminAccounts: ReadonlyArray<{
      readonly accountId: string;
      readonly " $fragmentSpreads": FragmentRefs<"IdentityAccountRow_account">;
    }>;
    readonly candidateAccounts: ReadonlyArray<{
      readonly accountId: string;
      readonly " $fragmentSpreads": FragmentRefs<"IdentityAccountRow_account">;
    }>;
    readonly code: number;
    readonly createdAt: string;
    readonly email: string;
    readonly employerAccounts: ReadonlyArray<{
      readonly accountId: string;
      readonly " $fragmentSpreads": FragmentRefs<"IdentityAccountRow_account">;
    }>;
    readonly firstName: string | null | undefined;
    readonly id: string;
    readonly identityUserId: string;
    readonly lastLoggedIn: string | null | undefined;
    readonly lastName: string | null | undefined;
    readonly updatedAt: string;
  } | null | undefined;
};
export type IdentityUserDetailsRouteQuery = {
  response: IdentityUserDetailsRouteQuery$data;
  variables: IdentityUserDetailsRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "identityUserCode"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "code",
    "variableName": "identityUserCode"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identityUserId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastLoggedIn",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountTypes",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v13 = [
  (v12/*: any*/),
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "IdentityAccountRow_account"
  }
],
v14 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v15 = [
  (v12/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "identityId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  (v10/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IdentityUserDetailsRouteQuery",
    "selections": [
      {
        "alias": "identityUser",
        "args": (v1/*: any*/),
        "concreteType": "IdentityUser",
        "kind": "LinkedField",
        "name": "identityUserByCode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "IdentityAccountModel",
            "kind": "LinkedField",
            "name": "adminAccounts",
            "plural": true,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IdentityAccountModel",
            "kind": "LinkedField",
            "name": "candidateAccounts",
            "plural": true,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IdentityAccountModel",
            "kind": "LinkedField",
            "name": "employerAccounts",
            "plural": true,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          (v14/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IdentityUserDetailsRouteQuery",
    "selections": [
      {
        "alias": "identityUser",
        "args": (v1/*: any*/),
        "concreteType": "IdentityUser",
        "kind": "LinkedField",
        "name": "identityUserByCode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "IdentityAccountModel",
            "kind": "LinkedField",
            "name": "adminAccounts",
            "plural": true,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IdentityAccountModel",
            "kind": "LinkedField",
            "name": "candidateAccounts",
            "plural": true,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IdentityAccountModel",
            "kind": "LinkedField",
            "name": "employerAccounts",
            "plural": true,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          (v14/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0179d7468245a53d4e84dcd1790bf17b",
    "id": null,
    "metadata": {},
    "name": "IdentityUserDetailsRouteQuery",
    "operationKind": "query",
    "text": "query IdentityUserDetailsRouteQuery(\n  $identityUserCode: Long!\n) {\n  identityUser: identityUserByCode(code: $identityUserCode) {\n    id\n    code\n    identityUserId\n    lastLoggedIn\n    updatedAt\n    createdAt\n    firstName\n    lastName\n    email\n    accountTypes\n    adminAccounts {\n      accountId\n      ...IdentityAccountRow_account\n    }\n    candidateAccounts {\n      accountId\n      ...IdentityAccountRow_account\n    }\n    employerAccounts {\n      accountId\n      ...IdentityAccountRow_account\n    }\n  }\n}\n\nfragment IdentityAccountRow_account on IdentityAccountModel {\n  identityId\n  accountId\n  type\n  email\n  firstName\n  lastName\n  description\n}\n"
  }
};
})();

(node as any).hash = "fd37e40ab0fa94c5eebe30d2e592d6f5";

export default node;
